module.exports = __webpack_public_path__ + "static/media/image194.b4147c86.png";